module.exports = __webpack_public_path__ + "img/fj-icon.49bd48e8.png";